var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8335 37.1963C25.8335 29.5299 32.24 23.3334 39.9892 23.3334C47.7604 23.3334 54.1668 29.5299 54.1668 37.1963C54.1668 41.0595 52.7618 44.6461 50.4493 47.686C47.8982 51.0392 44.7538 53.9608 41.2144 56.2541C40.4043 56.7841 39.6733 56.8241 38.7842 56.2541C35.2247 53.9608 32.0803 51.0392 29.551 47.686C27.2368 44.6461 25.8335 41.0595 25.8335 37.1963ZM35.3239 37.628C35.3239 40.1962 37.4196 42.2162 39.9892 42.2162C42.5606 42.2162 44.6764 40.1962 44.6764 37.628C44.6764 35.0797 42.5606 32.9614 39.9892 32.9614C37.4196 32.9614 35.3239 35.0797 35.3239 37.628Z",
    fill: "#004F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.4584740f75617cbac5adb657048548bb.svg";
export { ForwardRef as ReactComponent };